export enum EnumAppointmentPaymentStatus{
    None="None",
    Invoiced="Invoiced",
    InvoiceSubmitted="InvoiceSubmitted",
    Paid="Paid"
}